<micro-select-combo #sel
              placeholder="Sms Content Type"
              [mode]="mode"
              [(id)]="contentType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
